export const boxMenu = (selector) => {
    const switcher = document.querySelectorAll(selector);

    switcher.forEach((el) => {
        el.addEventListener('click', () => {
            el.parentNode.classList.toggle('c-box-menu--close');
        });
    });

};
